import useSWR from 'swr';
import { YoutubePlaylistVideo } from 'utils/getYoutubePlaylistVideos';

const fetcher = (url: string): Promise<{ videos: YoutubePlaylistVideo[] }> =>
  fetch(url).then((res) => res.json());

export interface UseYoutubeShortsResult {
  videos: YoutubePlaylistVideo[];
  isLoading: boolean;
}

// Client-side fetch for the homepage Shorts row so YouTube latency never blocks
// the page's TTFB. No polling -- shorts change slowly and the API route is
// edge-cached.
export function useYoutubeShorts(): UseYoutubeShortsResult {
  const { data, error } = useSWR('/api/youtube-shorts', fetcher, {
    revalidateOnFocus: false,
  });

  // SWR v1 has no isLoading flag: loading is the pre-response state.
  return { videos: data?.videos ?? [], isLoading: !data && !error };
}

export default useYoutubeShorts;
